<template>
    <section class="add-more-slider" v-if="sliderItems">
        <h2 class="sub-title">Вам также подходят</h2>
        <VueSlickCarousel v-bind="settings" class="carousel-items__slider slider slider-carousel">
            <div class="carousel-items__slider-item" v-for="sliderItem of sliderItems">
                <section class="item-card">
                    <a class="item-card__link" :href="sliderItem.url">
                        <img class="item-card__img lazy" :src="sliderItem.preview" :alt="sliderItem.name">
                    </a>
                    <div class="item-card__inner">
                        <h3 class="item-card__name h4">{{ sliderItem.name }}</h3>
                        <span class="item-card__price">от {{ sliderItem.price }} руб.</span>
                        <div class="item-card__btn-inner">
                            <a class="btn _secondary" :href="sliderItem.url">Подробнее</a>
                            <a class="btn _border" :href="sliderItem.url">Купить в 1 клик</a>
                        </div>
                    </div>
                </section>
            </div>
            <template #prevArrow="arrowOption">
                <button type="button" class="slick-arrow _prev">
                    <svg class="icon-arrow">
                        <use xlink:href="#arrow-slider"/>
                    </svg>
                </button>
            </template>
            <template #nextArrow="arrowOption">
                <button type="button" class="slick-arrow _next">
                    <svg class="icon-arrow">
                        <use xlink:href="#arrow-slider"/>
                    </svg>
                </button>
            </template>
        </VueSlickCarousel>
    </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'addMoreSlider',
    props: ['id'],
    components: {VueSlickCarousel},
    created() {
        this.$http.get('/api/products/'+this.id+'/more').then(res => {
            if(res.data.length) {
                this.sliderItems = res.data;
            }
        });
    },
    data() {
        return {
            settings: {
                arrows: true,
                infinite: true,
                slidesToScroll: 4,
                slidesToShow: 4,
                lazyLoad: "ondemand",
                responsive: [
                    {
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 994,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true
                        }
                    },
                ]
            },
            sliderItems: null,
        }
    },
}
</script>


